const API_BASE_URL =
  (typeof window !== 'undefined' && window.__RUNTIME_API_URL__) ||
  process.env.REACT_APP_API_URL ||
  'http://localhost:5001/api';

export default API_BASE_URL;
